import BaseModel from "../core/BaseModel";
export default class DepartmentModel extends BaseModel {
  constructor() {
    super(
      {
        name: "department",
        tableName: "department",
        label: "Quản Lý Bộ Phận",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: {
          name: "id",
          type: "Number",
          label: "ID",
          primaryKey: true,
          display: false,
        },

        name: {
          name: "name",
          type: "String",
          label: "Tên bộ phận",
          filter: { type: "input", match: "contains" },
        },

        active: {
          name: "active",
          type: "Boolean",
          label: "Hiển thị",
          class: "center"
        },

        updated_by: {
          name: "updated_by",
          type: "String",
          label: "Người cập nhật"
        },

        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },

        deleted: {
          name: "deleted",
          label: "Xóa",
          type: "Checkbox",
          display: false,
        },
      }
    );
  }
}
